import { passport, config } from "@imtbl/sdk";
import axios from "axios";
import { ethers } from "ethers";

const isLocalhost = window.location.hostname === "localhost";

export const passportInstance = new passport.Passport({
  baseConfig: {
    environment: config.Environment.PRODUCTION,
  },
  clientId: isLocalhost
    ? "0zVBU9Biei3EFItHcLafzyfHxvduJ8LQ"
    : "pGvnlPTHoBui5e8g36pg6VaaVvzip1fo",
  redirectUri: isLocalhost
    ? "http://localhost:3000/profile"
    : "https://qorbiworld.com/profile",
  logoutRedirectUri: isLocalhost
    ? "http://localhost:3000/profile"
    : "https://qorbiworld.com/profile",
  audience: "platform_api",
  scope: "openid offline_access email transact",
});

export async function transferERC1155(
  receiverAddress,
  tokenAddress,
  tokenId,
  amount
) {
  try {
    // Ensure user is authenticated
    let accessToken = await passportInstance.getAccessToken();
    if (!accessToken) {
      await passportInstance.login();
      accessToken = await passportInstance.getAccessToken(); // Get token after login
    }

    // Get provider and signer (Ethers v5 syntax)
    const provider = new ethers.providers.Web3Provider(
      await passportInstance.connectEvm()
    );
    const signer = provider.getSigner();
    const sender = await signer.getAddress();

    // Create transfer request
    const transferData = {
      receiver: receiverAddress,
      token: {
        type: "ERC1155",
        tokenAddress,
        tokenId,
        amount: amount.toString(),
      },
    };

    // Call Immutable X API to execute the transfer
    const response = await axios.post(
      "https://api.sandbox.immutable.com/v1/transfers", // Use mainnet URL for production
      transferData,
      {
        headers: {
          Authorization: `Bearer ${await passportInstance.getAccessToken()}`,
        },
      }
    );

    console.log("ERC-1155 Transfer Successful:", response.data);
    return response.data;
  } catch (error) {
    console.log(
      "Error transferring ERC-1155 asset:",
      error.response?.data || error.message
    );
  }
}
